import angular from 'angular';
import moment from 'moment';

(function () {
    'use strict';
    angular.module('app.core').factory('InvitedEntity', InvitedEntityData);

    InvitedEntityData.$inject = ['LegalEntity', '$translate', 'KISS_INVITED_ENTITY'];

    /* @ngInject */
    function InvitedEntityData(LegalEntity, $translate, KISS_INVITED_ENTITY) {
        InvitedEntity.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getIENameWithId: getIENameWithId,
            getCountryLabel: getCountryLabel,
            getLangLabel: getLangLabel,
            getStatusLabel: getStatusLabel,
            isCreated: isCreated,
            isNotified: isNotified,
            isActive: isActive,
            isInactive: isInactive,
            isDuplicate: isDuplicate,
            getName: getName,
            getEntityTypeLabel: getEntityTypeLabel,
            isBuyer: isBuyer,
            isSeller: isSeller,
            isInvited: isInvited
        };

        function InvitedEntity(InvitedEntityData) {
            if (!InvitedEntityData) {
                this.buildEmpty();
            } else {
                this.build(InvitedEntityData);
            }
        }

        return InvitedEntity;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.legalEntity = new LegalEntity();
            this.invoiceSenderEmail = null;
            this.sellerRobotKey = null;
            this.invoiceEmailShared=false;
            this.notificationEmail = null;
            this.cguAckDate = null;
            this.legalForm = null;
            this.registrationPlace = null;
            this.capital = null;
            this.capitalCurrency = null;
            this.insurance = null;
            this.status = null;
            this.entityType = null;
            this.invitedEntityTypes = null;
            this.remindcount = null;
            this.biProfil = false;
            this.idBiProfil = null;
            this.hasRelation = false;
            this.invoiceRecieverEmail = null;
        }

        function build(InvitedEntityData) {
            this.id = InvitedEntityData.id || null;
            this.legalEntity = new LegalEntity(InvitedEntityData.legalEntity);
            this.invoiceSenderEmail = InvitedEntityData.invoiceSenderEmail || null;
            this.sellerRobotKey = InvitedEntityData.sellerRobotKey || null;
            this.invoiceEmailShared = InvitedEntityData.invoiceEmailShared || false;
            this.notificationEmail = InvitedEntityData.notificationEmail || null;
            if (InvitedEntityData.cguAckDate) {
                this.cguAckDate = moment(InvitedEntityData.cguAckDate).toDate() || null;
            }
            this.legalForm = InvitedEntityData.legalForm || null;
            this.registrationPlace = InvitedEntityData.registrationPlace || null;
            this.capital = InvitedEntityData.capital || null;
            this.capitalCurrency = InvitedEntityData.capitalCurrency || null;
            this.insurance = InvitedEntityData.insurance || null;
            this.status = InvitedEntityData.status || null;
            this.entityType = InvitedEntityData.entityType || null;
            this.invitedEntityTypes = InvitedEntityData.invitedEntityTypes || null;
            this.lastRemindDate = InvitedEntityData.lastRemindDate;
            this.remindcount = InvitedEntityData.remindcount || 0;
            this.biProfil = InvitedEntityData.biProfil || false;
            this.idBiProfil = InvitedEntityData.idBiProfil || null;
            this.hasRelation = InvitedEntityData.hasRelation || false ;
        }

        function getIENameWithId() {
            if (this.legalEntity) {
                return this.legalEntity.getNameForList();
            }
            return '';
        }

        function getLangLabel() {
            return $translate.instant('lang.' + angular.lowercase(this.legalEntity.language));
        }

        function getStatusLabel() {
            if (this.status) {
                return $translate.instant('kiss_invited_entity.status.' + angular.lowercase(this.status));
            }
            return '';
        }

        function getCountryLabel() {
            //return $translate.instant('country.' + angular.lowercase(this.legalEntity.countryCode));
            if (this.legalEntity) {
                return this.legalEntity.getCountryLabel();
            }
            return '';
        }

        function getEntityTypeLabel() {
            if (this.invitedEntityTypes) {
                return $translate.instant('kiss_invited_entity.type.' + angular.lowercase(this.invitedEntityTypes));
            }
            return '';
        }

        function isCreated() {
            return this.status && this.status === KISS_INVITED_ENTITY.invited_entity.status[0].value;
        }

        function isNotified() {
            return this.status && this.status === KISS_INVITED_ENTITY.invited_entity.status[1].value;
        }

        function isActive() {
            return this.status && this.status === KISS_INVITED_ENTITY.invited_entity.status[2].value;
        }

        function isInactive() {
            return this.status && this.status === KISS_INVITED_ENTITY.invited_entity.status[3].value;
        }

        function isDuplicate() {
            return this.status && this.status === KISS_INVITED_ENTITY.invited_entity.status[4].value;
        }

        /**
         * Fournit le nom et l'id .
         * La fonction s'appelle "getName" pour son utilisation dans Typeahead afin d'avoir le même même nom que dans principal-detail.data.
         */
        function getName() {
            return this.getIENameWithId();
        }

        function isBuyer() {
            return this.invitedEntityTypes && this.invitedEntityTypes === 'BUYER';
        }

        function isSeller() {
            return this.entityType && this.entityType === KISS_INVITED_ENTITY.invited_entity.type[2].value;
        }

        function isInvited() {
            return this.invitedEntityTypes && this.invitedEntityTypes === 'INVITED';
        }
    }
})();
